import useCurrentFamily from '~/familyAccount/hooks/useCurrentFamily'

/**
 * The licence floor for the price pages. An existing family admin can only add learners here —
 * removing one has to happen in the admin panel, where they can pick which profile loses access.
 * So their current licence count is both the starting value and the minimum.
 * Returns 1 for everyone else.
 */
export default function useMinimumFamilyLicenses(): number {
  const { familyInfo } = useCurrentFamily()

  return Math.max(familyInfo?.licenseCount ?? 0, 1)
}
